export default (() =>{

    /** Recupero URI dell'api dal file config.json **/
    let base_url = null;
    const request = new XMLHttpRequest();
    request.open('GET','/config.json');
    request.onload = function(response){
        response = JSON.parse(response.target.responseText);
        const ref_ip = response.config.ip;                
        base_url = ref_ip + ((ref_ip[ref_ip.length-1] == '/')?'':'/') + 'api/'; 
    }
    request.send();

    const allowed_methods = ['GET','POST','PUT','HEAD'];
    const default_options = {
        headers : [
            {field:'Content-Type',value:'application/json'}
        ],
    }

    return {
        AjaxRequest(options){
            if(options == undefined){ throw 'Network: opzioni non valide'; }
    
             /** Controllo URL (o controller) **/
             let URL = '';
             if(options.URL!=undefined ){
                URL = options.URL;
             }else if( options.controller!=undefined ){
                URL = base_url + options.controller;
             }else{
                throw 'Network: nessun URL o Controller specificato';
             }

             /** Valorizzazione campi undefined con valori di default */
            const default_fields = Object.keys(default_options);
            for(let i=0; i < default_fields.length; i++){
                const field = default_fields[i];
                if(options[field]==undefined){options[field] = default_options[field];}  
            }

            /** Controllo metodo **/              
            const method_index = allowed_methods.indexOf(options.method.toUpperCase());
            if(method_index<0){ throw 'Network: il metodo specificato non è valido'; }

            const request = new XMLHttpRequest();
            request.open(allowed_methods[method_index], URL);  

            /** Impostazione header chiamata **/
            for(let i=0;i<options.headers.length;i++){ 
                request.setRequestHeader(options.headers[i].field, options.headers[i].value); 
            } 
            
             /** Impostazione timeout **/
            if( options.timeout!=undefined && options.timeout>0){ 
                request.timeout=options.timeout; 
            }

            /** Impostazione callback **/
            if(options.on!=undefined){
                
                /** Callback per eventi della richiesta **/
                const request_events = ['error', 'abort', 'load', 'loadstart', 'loadend', 'readystatechange', 'progress', 'timeout'];                          
                for(let i=0; i < request_events.length; i++){
                    const request_event = request_events[i];
                    if(options.on[request_event] != undefined){
                        request.addEventListener(request_event, options.on[request_event]);
                    }
                }

                /** Callback per eventi di upload **/
                const upload_events = [ 'error', 'abort', 'load', 'loadstart', 'loadend', 'progress', 'timeout'];
                for(let i=0; i < upload_events.length; i++){
                    const upload_event = upload_events[i];
                    if(options.on.upload[upload_event] != undefined){
                        request.upload.addEventListener(upload_event, options.on.upload[upload_event]);
                    }
                }
            }

            /** Invio richiesta **/
            request.send(JSON.stringify(options.body)); 
        }
    }
})();